// in file: data/personnelFormData.ts

import { IPersonnel, ITimesheetForm, ICalendar } from "../interface/Personnel";

export const personnelFormDataModal: IPersonnel = {
  personalID: 0,
  stafF_ID: 0,
  ssn: "",
  lastname: "",
  firstname: "",
  mi: "",
  street: "",
  city: "",
  state: "",
  zipcode: "",
  homephone: "",
  workphone: "",
  otherphone: "",
  doemp: null,
  doterm: null,
  dob: null,
  wpreq: false,
  wprec: false,
  clR2BMAIL: null,
  clearmail: null,
  clearrec: null,
  app: false,
  w4: false,
  i9: false,
  medicalexp: null,
  tineexp: null,
  reF_P_OUT: null,
  reF_P_REC: null,
  reF_W1_OUT: null,
  reF_W1_REC: null,
  reF_W2_OUT: null,
  reF_W2_REC: null,
  fingercnty: "",
  sitE_NUM_B: 0,
  sitE_NAM_B: "",
  sitE_POS_B: "",
  sitE_NUM_D: 0,
  sitE_NAM_D: "",
  sitE_POS_D: "",
  sitE_NUM_A: 0,
  sitE_NAM_A: "",
  sitE_POS_A: "",
  moN_1_B: "",
  moN_1_E: "",
  moN_2_B: "",
  moN_2_E: "",
  moN_3_B: "",
  moN_3_E: "",
  tuE_1_B: "",
  tuE_1_E: "",
  tuE_2_B: "",
  tuE_2_E: "",
  tuE_3_B: "",
  tuE_3_E: "",
  weD_1_B: "",
  weD_1_E: "",
  weD_2_B: "",
  weD_2_E: "",
  weD_3_B: "",
  weD_3_E: "",
  thU_1_B: "",
  thU_1_E: "",
  thU_2_B: "",
  thU_2_E: "",
  thU_3_B: "",
  thU_3_E: "",
  frI_1_B: "",
  frI_1_E: "",
  frI_2_B: "",
  frI_2_E: "",
  frI_3_B: "",
  frI_3_E: "",
  paY_RATE_B: 0,
  seP_PAY_RATE_B: 0,
  jaN_PAY_RATE_B: 0,
  salarY_B: 0,
  maX_HRS_B: 0,
  paY_RATE_D: 0,
  seP_PAY_RATE_D: 0,
  jaN_PAY_RATE_D: 0,
  salarY_D: 0,
  maX_HRS_D: 0,
  paY_RATE_A: 0,
  seP_PAY_RATE_A: 0,
  jaN_PAY_RATE_A: 0,
  salarY_A: 0,
  maX_HRS_A: 0,
  comments: "",
  idca: false,
  education: "",
  daysoff: 0,
  allused: false,
  datesused: "",
  referedby: "",
  statE_FPC: null,
  statE_FPR: null,
  hireletter: false,
  cntY_FPC: null,
  cntY_FPR: null,
  reF_P_FON: null,
  reF_W1_FON: null,
  reF_W2_FON: null,
  iD1: false,
  iD2: false,
  maX_ADD_B: 0,
  maX_ADD_D: 0,
  maX_ADD_A: 0,
  dsS_POS: "",
  absences: "",
  nysid: "",
  gender: "",
  daysused: 0,
  perC_B: 0,
  perC_D: 0,
  perC_A: 0,
  matapp: null,
  cpr: null,
  firstaid: null,
  matdate: null,
  raiseeffb: null,
  raiseeffd: null,
  raiseeffa: null,
  rehireable: false,
  comment: "",
  email: "",
  personal_email: "",
  emernamE1: "",
  emerphonE1: "",
  emercelL1: "",
  emernamE2: "",
  emerphonE2: "",
  emercelL2: "",
  dayemerg: "",
  rehired: null,
  allottedb: 0,
  allottedd: 0,
  allotteda: 0,
  aidefoR1: "",
  aidefoR2: "",
  aidefoR3: "",
  matStart: null,
  sel: null,
  personalFieldSupervisor: "",
  personalFieldTrainer: "",
  personalHHC: "",
  type: 0,
  effectiveDateBefore: null,
  effectiveDateDuring: null,
  effectiveDateAfter: null,
  foundations: null,
  leaveOfAbsense: false,
  leaveStartDate: null,
  leaveEndDate: null,
  suspensionStartDate: null,
  suspensionEndDate: null,
  leaves: false,
  leavesStart: null,
  leavesEnd: null,
  suspension: false,
  suspensionStart: null,
  suspensionEnd: null,
  expungeDate: null,
  aloneWithChildren: false,
  flagType: false,
  sHarassmentExp: null,
  // sHarassmentExp2: null,
  cbc: null,
  aces: null,
  eLaw: null,
  fingerprintDate: null,
  foundations15H: null,
  closed: undefined
};

export const personnelTimesheetFormDataModal: ITimesheetForm = {
  timesheetID: 0,
  districtID: 0,
  siteID: 0,
  schoolID: 0,
  personID: 0,
  position: "",
  timeSheetDate: null,
  // timeIn: { ticks: 0 },
  timeIn: "",
  timeOut: "",
  siteTimeIn: "",
  siteTimeOut: "",
  paycode: '',
  externalEventId: null,
  lunchIn: "",
  additionalStart: "",
  lunchOut: "",
  additionalStop: "",
  deviceID: "",
  type: 0,
  createdBy: "",
  modifiedBy: "",
  clockInLocal: null,
  clockOutLocal: null,
  notesHeader: "",
  notesDetails: "",
};

export const calendarFormDataModal: ICalendar = {
  id: 0,
  siteID: 0,
  personID: 0,
  // siteTypeBefore: false,
  // siteTypeDuring: false,
  // siteTypeAfter: false,
  siteType: 'before',
  position: '',
  notes: '',
  date: null,
  // timeIn: '',
  // timeOut: '',
  // lunchIn: '',
  // lunchOut: '',
  // additionalStart: '',
  // additionalStop: '',

  mondayTimeIn: '',
  mondayTimeOut: '',

  tuesdayTimeIn: '',
  tuesdayTimeOut: '',

  wednesdayTimeIn: '',
  wednesdayTimeOut: '',

  thursdayTimeIn: '',
  thursdayTimeOut: '',

  fridayTimeIn: '',
  fridayTimeOut: '',
  paycode: ''
}

export interface ICertificateForm {
  certificateID: 0,
  certificateTypeID: 0,
  personID: 0,
  certificatePermanent: false,
  certificateProfessional: false,
  certificateCQ: false,
  initial: false,
  initialExpiration: null,
  provisional: false,
  provisionalExpiration: null,
}

export interface ICertificateTable {
  certificateTypeID: 0,
  certificatePermanent: false,
  certificateProfessional: false,
  certificateCQ: false,
  initial: false,
  initialExpiration: null,
  provisional: false,
  provisionalExpiration: null,
  [key: string]: any;
}

export interface IAttendanceForm {
  districtID: 0,
  attendanceID: 0;
  staffId: 0;
  date: null,
  reason: null,
  paid: false,
  charged: false,
  fraction: null,
  siteNumber: 0;
  siteName: null,
  reasonID: 0;
}

export interface IAttendanceTable {
  attendanceID: 0;
  staffId: 0;
  date: null,
  reason: null,
  paid: false,
  charged: false,
  fraction: null,
  siteNumber: 0;
  siteName: null,
  reasonID: 0;
  [key: string]: any; // Optional: to allow additional properties
}
export interface IWaiverForm {
  waiversSentID: 0;
  staffId: 0;
  sent: null,
}

export interface IWaiverTable {
  sent: null,
  [key: string]: any; // Optional: to allow additional properties
}
